export const AUTHENTICATE_USER = 'AUTHENTICATE_USER';
export const SET_ERROR = 'SET_ERROR';
export const SHOW_ADD_MODAL = 'SHOW_ADD_MODAL';
export const SHOW_EDIT_MODAL = 'SHOW_EDIT_MODAL';
export const GET_USER_TICKETS = "GET_USER_TICKETS";
export const GET_ALL_TICKETS = "GET_ALL_TICKETS";
export const UPDATE_TABLE_ENTRIES = "UPDATE_TABLE_ENTRIES";
export const SELECTED_TICKET = "SELECTED_TICKET";
export const GET_USER = "GET_USER";
export const LOGOUT = "LOGOUT";
